import React, { useState } from 'react';
import { Menu, Dropdown, Badge, Avatar, List, Button, Popconfirm } from 'antd';
import { 
  FileDoneOutlined, 
  BellOutlined,
  CloseOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import Flex from 'components/shared-components/Flex'
import { useEffect } from 'react';
import Utils from 'utils';
import SamacLib from 'lib/samac';
import moment from 'moment'
import "./NavNotification.css"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsersGear, faUsersSlash } from '@fortawesome/free-solid-svg-icons';

const getIcon =  icon => {
  switch (icon) {
    case 'report':
      return <FileDoneOutlined />;
    case 'nominee':
      return <FontAwesomeIcon icon={faUsersGear} style={{fontSize:"17px", marginLeft: ".02rem", marginTop: ".7rem"}}/>
    case 'nominee_revoked':
      return <FontAwesomeIcon icon={faUsersSlash} style={{fontSize:"17px", marginLeft: ".02rem", marginTop: ".7rem"}}/>
    case 'planneddayrequest':
      return <CalendarOutlined />;
    default:
      return <BellOutlined />;
  }
}

const getType = level => 
{
  switch (level) {
    case 'INFO':
      return 'info';
    case 'WARN':
      return 'warning';
    case "ERROR":
    default:
      return 'danger';
  }
}

const parseBody = body => {
  return <span dangerouslySetInnerHTML={{__html: body}}></span>
}

const getTime = ts => {
  let rv = "N.D";
  if(Utils.dateIsValid(ts))
  {
    let date = moment(ts);
    let today = new Date();
    let yesterday = new Date();
    yesterday = yesterday.setDate(yesterday.getDate()-1);
    let isToday = date.isSame(today, "day");
    let isYesterday = date.isSame(yesterday, "day");
    rv = isToday ? date.format(SamacLib.GetTimeFormat()) : isYesterday ? "ieri" : date.format(SamacLib.GetShortDateFormat());
  }
  return rv;
}


export const NavNotification = (props) => {

  const { 
		notifications
  } = props

  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([])

  let hideNotification = (id) => {
    let oldNot = Utils.deepClone(data);
    let notIdx = oldNot.findIndex(n => n.id === id)
    if(notIdx >= 0)
    {
      oldNot[notIdx].visible = false
      setData(oldNot)
      setTimeout(() => {
        let oldNot = Utils.deepClone(data);
        oldNot.splice(notIdx, 1)
        setData(oldNot)
      }, 300)
    }
  }

  let crossClicked = (item) => {
    SamacLib.DeleteRequest('notification/'+item.id, {}, true).then((body) => {
      if(body.status === 1)
      {
        hideNotification(item.id);
      }
      else
      {
        SamacLib.HandleResponse(body);
      }
    });
  }

  let IsJsonString = (str) => {
    try {
      var json = JSON.parse(str);
      return (typeof json === 'object');
    } catch (e) {
      return false;
    }
  }

  let getJsonLink = (data) => {
    if(data !== undefined && data !== "" && IsJsonString(data))
    {
      let json = JSON.parse(data);
      if(json.link !== undefined && json.link !== "")
      {
        return <>&nbsp;<a href={json.link} size="small">(Vedi)</a></>
      }
    }
  }

  let acceptNominee = (id, data) => {
    if(data !== undefined && data !== "" && IsJsonString(data))
    {
      let json = JSON.parse(data);
      if(json.SequenceId !== undefined && json.SequenceId !== "" &&
         json.JobId !== undefined && json.JobId !== "" &&
         json.LnId !== undefined && json.LnId !== "" &&
         json.RoleId !== undefined && json.RoleId !== "")
      {
        SamacLib.PutRequest('/nominees/', json).then(() => {
          hideNotification(id);
          SamacLib.ForceSectionReload("dashboard.nomineeTable")
        });
      }
    }
  }

  const getNotificationBody = list => {
    return list.length > 0 ?
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={list}
      renderItem={item => (
        <motion.div 
          initial={{ opacity: 0, marginBottom: 0 }} 
          animate={{ 
            opacity: item.visible ? 1 : 0,
            marginBottom: item.visible ? 0 : 0,
          }}>
          <List.Item className="list-clickable">
            <Flex>
              <div className="pr-3">
                {item.img? <Avatar src={`/img/avatars/${item.img}`} /> : <Avatar className={`ant-avatar-${getType(item.level)}`} icon={getIcon(item.icon)} />}
              </div>
              <div className="mr-3" style={{minWidth: "10rem"}}>
                <span className="font-weight-bold text-dark">{item.title} </span><br/>
                <span className="text-gray-light">{parseBody(item.body)}
                {getJsonLink(item.data)}
                </span><br/>
                {item.icon === "nominee" ? <>
                  <span>
                  <Popconfirm style={{width: "10rem"}} title="Confermi di accettare la nomina?" okText="Si" 
					          cancelText="Annulla" cancelButtonProps={{ style: { padding: '3px .5rem' } }} okButtonProps={{ style: { padding: '3px .75rem' } }}  onConfirm={() => acceptNominee(item.id, item.data)}>
                    <Button 
                      type='primary'
                      style={{marginTop: ".5rem", padding: "0.2rem 0.5rem", height:"fit-content"}} size='small'>Accetta</Button>
                    </Popconfirm></span></>: <></>}
                
              </div>
              <div style={{display: "grid"}}>
                <span style={{textAlign: "right"}}>
                  {item.icon !== "nominee" && <CloseOutlined onClick={() => crossClicked(item)} className='cross'  />}
                </span>
                <span style={{marginTop: "-.65rem"}}>
                  <small className="ml-auto">{getTime(item.ts)}</small>
                </span>
              </div>
            </Flex>
          </List.Item>
        </motion.div>
      )}
    />
    :
    <div className="empty-notification">
      <img src="/img/noNotifications.svg" alt="empty" />
      <p className="mt-3">Non ci sono notifiche da mostrare</p>
    </div>;
  }

  //GESTITO COME COSTRUTTORE
  useEffect(() => {
    if (notifications !== undefined) {
      notifications.sort(function(a, b) {
        return moment(b.ts).valueOf() - moment(a.ts).valueOf();
      }).sort(function(a,b){
        return b.id - a.id
      })
      notifications.forEach(not => {
        not.visible = true;
      });
      setData(notifications)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications]);

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  }

  const notificationList = (
    <div className="nav-dropdown nav-notification">
      <div className="nav-notification-header d-flex justify-content-between align-items-center" style={{padding: "0.25rem"}}>
        <h4 className="mb-1 mt-2 ml-2">Notifiche</h4>
        {/*<Button className="text-primary" style={{marginRight: "-0.25rem"}} type="link" onClick={() => setData([])} size="small">Cancella tutte</Button>*/}
      </div>
      <div className="nav-notification-body">
        {getNotificationBody(data)}
      </div>
      {
        data.length > 0 ? 
        <div className="nav-notification-footer">
          {/*<a className="d-block" href="#/">Vedi tutte</a>*/}
        </div>
        :
        null
      }
    </div>
  );

  return (
    <Dropdown 
      placement="bottomRight"
      overlay={notificationList}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      trigger={['click']}
      getPopupContainer={trigger => trigger.parentNode}
    >
      <Menu mode="horizontal">
        <Menu.Item key="notification">
          <Badge count={data.length}>
            <BellOutlined className="nav-icon" type="bell" />
          </Badge>
        </Menu.Item>
      </Menu>
    </Dropdown>
  )
}


export default NavNotification;
